import { render } from "./BelegButtonVersionsvergleichExtraFieldTableRow.pug?vue&type=template&id=4835d860&lang=pug"
import script from "./BelegButtonVersionsvergleichExtraFieldTableRow.js?vue&type=script&lang=js"
export * from "./BelegButtonVersionsvergleichExtraFieldTableRow.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__